<template>
    <div class="pages">
        <div class="title mb-30">
            <p>
                <img src="../../assets/images/newIcon/newimport_icon.png" alt="">
                <span>新建导入</span>
            </p>
            <p>
            </p>
        </div>
        <div class="content">
            <ul class="checkTab mb-30">
                <li :class="{'active':types==1 || types==2 || types==3}">
                    <p>1</p>
                    <p>上传导入文件</p>
                </li>
                <li :class="{'active':types==2 || types==3}">
                    <p>2</p>
                    <p>确认导入文件</p>
                </li>
                <li  :class="{'active':types==3}">
                    <p>3</p>
                    <p>导入成功</p>
                </li>
            </ul>
            <div class="c1" v-show="types==1">
                <el-form ref="form" label-position="right" label-width="120px" :model="forms">
                    <el-form-item prop="pone" label="导入识别方式：" :rules="[
      { required: true, message: '手机号码识别', trigger: 'blur' }]">
                        <p class="p1">手机号码识别</p>
                        <p class="p2">目前仅支持手机号作为唯一识别方式，其他识别方式敬请期待～</p>
                    </el-form-item>
                     <el-form-item prop="fileList" label="上传文件：" :rules="[
      { required: true, message: '请选择导入文件', trigger: 'change' }]">
                        <el-upload
                        class="upload-demo"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        multiple
                        :limit="3"
                        :on-exceed="handleExceed"
                        :file-list="forms.fileList">
                        <el-button type="text" style="font-size:16px;" icon="el-icon-plus">添加文件</el-button>
                        <div slot="tip" class="el-upload__tip">当前仅支持csv格式文件（文件大小在10M以内且行数在10万以内，若超出限制，请分批导入），请使用Office 2010及以上版本，否则可能出现乱码
必须严格按照模板内容填入客户数据，否则可能会出现导入异常：<el-button type="text">下载模版（可点击自动下载导入模版）</el-button></div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="">
                        <el-checkbox v-model="forms.checked">我已阅读并同意 </el-checkbox>
                        <el-button type="text">《数据导入免责声明》</el-button>
                    </el-form-item>
                </el-form>
                
            </div>
            <div class="tab2" v-show="types==2">
                <div class="f4 bf">
                    <div class="d1">
                        <p>共<span>{{total}}</span>条 已选中<span>0</span>条</p>
                        <p>
                            <el-button icon="el-icon-delete" plain class="kh-btn" @click="batchDelete"> 批量删除</el-button>
                            <!-- <el-button @click="showExport" style="background:#327EFF;" type="primary" round><img src="../../assets/images/newIcon/vip_daochu_icon.png" alt=""> 会员导出</el-button> -->
                        </p>
                    </div>
                    <el-table
                        :data="tableData3"
                        :header-cell-style="{background:'#EEEEEE',textAlign:'center',fontSize:'12px'}"
                         :cell-style="{textAlign:'center',fontSize:'12px'}"
                        style="width: 100%;"
                        >
                        <el-table-column
                        type="selection"
                        width="55">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        width="150"
                        label="手机号"
                        show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                        prop="number"
                        class="tab-14"
                        width="100"
                        label="名称"
                        >
                        <template slot-scope="scope">
                            <div>   
                                <img class="userImg" src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                                <span class="font-14" >{{scope.row.number}}</span>
                            </div>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="xmember"
                        label="性别"
                        
                        cell-style="background:red;"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="lmember"
                        label="生日"
                    >
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="备注"
                        show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                        prop="she"
                        label="省"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="shi"
                        label="市"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="标签"
                        width="240"
                        >
                            <template slot-scope="scope">
                                <div class="labelLi">
                                    <p>标签111</p>
                                    <p>标签222</p>
                                    <el-popover
                                    placement="bottom"
                                    width="200"
                                    trigger="click">
                                    <div class="labelAll">
                                        <el-tag>标签一</el-tag>
                                        <el-tag>标签一</el-tag>
                                    </div>
                                    <span class="s" slot="reference">...</span>
                                    </el-popover>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                        prop="dj"
                        label="会员等级"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="jf"
                        label="会员积分"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="操作"
                        >
                            <template slot-scope="scope">
                                <el-button type="text" @click="onDelete">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="query.page_index"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="query.page_size"
                    layout="prev, pager, next, sizes, jumper"
                    :total="total"
                    ></el-pagination>
                </div>
            </div>
            <div class="tab3" v-show="types==3">
                <p><img src="../../assets/images/newIcon/import_icon.png" alt=""></p>
                <p>导入中</p>
                <p>（后续系统会自动导入，不需要在该界面继续等待）</p>
                <p>预计导入xxx人数，成功后可在会员导入中查看</p>
                <p>
                    <el-button type="primary" @click="goList" round>继续导入</el-button>
                </p>
            </div>
        </div>

        <span v-if="types!=3" class="footer">
            <el-button class="quxiao" @click="handleClose" v-if="types==1">取 消</el-button>
            <el-button class="quxiao" @click="goType(1)" v-if="types==2">暂不导入</el-button>
            <el-button type="primary" v-if="types!=3"  @click="goType(2)">{{types==2 ? '导 入' : '下一步'}}</el-button>
            <!-- <el-button type="primary" v-if="types==3" @click="goType(2)">完成</el-button> -->
        </span>
        <el-dialog
        title="批量导入提醒"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
            <div class="dlog">
                <p class="t">支持对某个客户进行重复导入，每次导入都会覆盖原本客户资产信息：</p>
                <p class="ner"><i></i> 基本覆盖信息及导入文件为准</p>
                <p class="ner"><i></i> 手机号码是唯一标示，若导入重复系统会自动去重</p>
                <p class="f">注：请谨慎使用该功能，尤其是对同一批客户重复导入时</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="config">确定导入</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    props:{
        
    },
    data() {
        return {
            dialogVisible:false,
            query:JSON.parse(JSON.stringify(QUERY)),
            forms:{
                checked:false,
                fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}],
                pone:"1866412"
            },
            tableData3: [{
                name: '15018505692',
                number:"王小虎",
                xmember:"男",
                lmember:"2021.10.12 18:00",
                labellv:"30天内…",
                she:"广东省",
                shi:"深圳市",
                dj:"黄金会员",
                jf:"100"
                },{
                name: '15018505692',
                number:"王小虎",
                xmember:"男",
                lmember:"2021.10.12 18:00",
                labellv:"30天内…",
                she:"广东省",
                shi:"深圳市",
                dj:"黄金会员",
                jf:"100"
                },{
                name: '15018505692',
                number:"王小虎",
                xmember:"男",
                lmember:"2021.10.12 18:00",
                labellv:"30天内…",
                she:"广东省",
                shi:"深圳市",
                dj:"黄金会员",
                jf:"100"
                },{
                name: '15018505692',
                number:"王小虎",
                xmember:"男",
                lmember:"2021.10.12 18:00",
                labellv:"30天内…",
                she:"广东省",
                shi:"深圳市",
                dj:"黄金会员",
                jf:"100"
                },{
                name: '15018505692',
                number:"王小虎",
                xmember:"男",
                lmember:"2021.10.12 18:00",
                labellv:"30天内…",
                she:"广东省",
                shi:"深圳市",
                dj:"黄金会员",
                jf:"100"
                },{
                name: '15018505692',
                number:"王小虎",
                xmember:"男",
                lmember:"2021.10.12 18:00",
                labellv:"30天内…",
                she:"广东省",
                shi:"深圳市",
                dj:"黄金会员",
                jf:"100"
            },],
            total:4,
            dialogVisible:false,
            types:1,
            titles:["","修改客户等级","修改客户积分","批量打客户标签","选择标签"],
            tags:["成交拉","核心"]
        }
    },
    methods: {
        //点击删除
        onDelete(){
                      this.$confirm('是否确定删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          roundButton:true,
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        },
        //批量删除
        batchDelete(){
           this.$confirm('此操作将批量删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          roundButton:true,
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        },
        handleClose(e){
            this.dialogVisible=false;
            // this.types=0;
        },
        goList(){
            this.$router.go(-1);
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        goType(t){
            if(t==1){
                this.types=--this.types;
            }else{
                console.log(this.types,111)
                let istrue=true;
                if(this.types==1){
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            if(!this.forms.checked){
                                istrue=false;
                                this.$message.error("请先阅读并勾选声明")
                            }
                            // this.types=++this.types;    
                        } else {
                            console.log('error submit!!');
                            istrue=false;
                        }
                    });
                }
                if(this.types==2){
                    this.show();
                    return false;
                }
                if(istrue){
                     this.types=++this.types;    
                }
            }
        },
        show(item){
            this.dialogVisible=true;
        },
        hidelod(){
            this.dialogVisible=false;
            this.types=0;
        },
        cong(){
            if(this.types==1 ||this.types==2){//等级 或积分
                let a=this.$refs.customerLevel.set();
                this.$emit("doSelect",a);
                this.dialogVisible=false;
            }else if(this.types==3 || this.types==4){//打标签
                let tags=this.$refs.customerLabel.set();
                if(this.types==3){
                    this.dialogVisible2=true;
                }else{
                    this.$emit("doSelect",tags);
                }
                this.dialogVisible=false;
            }
            this.types=0;
            
        },
        config(){
            this.dialogVisible=false;
            this.types=3;
        },
        handleSizeChange(val) {
        this.query.page_size = val;
        // this.getTableData();
        },
        handleCurrentChange(val) {
            this.query.page_index = val;
            // this.getTableData();
        },
    },
}
</script>
<style lang="less" scoped>
.title{
    display: flex;
    justify-content: space-between;
    p{
        font-size: 16px;
        font-weight: 500;
        color: #333940;
        img{
            margin-right:10px;
            width:20px;
            height:20px;
            vertical-align: middle;
            &:last-child{
                margin-left:10px;
                width:78px;
                height:20px;
            }
        }
        &:last-child{
            span{
                color: #0091FF;
            }
        }
        
    }
}
.quxiao.el-button{
    color: rgba(37, 49, 62, 0.45);
}
.content{
    // padding:30px;
    .checkTab{
        background: #fff;
        padding:60px 0;
        display: flex;
        justify-content: center;
        li{
            margin-right:220px;
            position: relative;
            &:last-child{
                margin:0;
                &::after{
                    left: -206px;
                }
            }
            &:first-child{
                
                &::after{
                    display:none;
                }
                
            }
            &:nth-child(2){
                &::after{
                    left: -205px;
                }
                
            }
            
            &::after{
                content: '';
                position: absolute;
                top: 30px;
                border-bottom: 1px dashed #A7A7A7;
                width: 190px;
                height: 2px;
            }
        }
        .active{
            &::after{
                border-bottom: 1px dashed #327EFF;
            }
            p{
                &:last-child{
                    color: #327EFF;
                }
                &:first-child{
                    background: linear-gradient(180deg, #587FFB 0%, #3968FC 100%);
                    color:#fff;
                }
            }
        }
        p{
            text-align: center;
            &:first-child{
                margin:0 auto;
                margin-bottom:15px;
                width: 64px;
                height: 64px;
                border-radius: 50%;
                line-height: 64px;
                text-align: center;
                background: #EBEBEB;
                font-size: 34px;
                font-weight: 500;
                color: #fff;
            }
            &:last-child{
                font-size: 14px;
                font-weight: 400;
                color: #A1A1A1;
            }
        }
    }
    .title{
        padding:15px;
        background: rgba(73, 116, 251, 0.11);
        border-radius: 4px;
        img{
            width:16px;
            height:16px;
            vertical-align: middle;
        }
        font-size: 14px;
        font-weight: 400;
        color: #258EF7;
    }
    .c1{
        background: #fff;
        padding:30px;
        /deep/ .el-form{
            width:70%;
        }
        /deep/ .el-upload{
            display: flex;
            justify-content: flex-start;
        }
        /deep/ .el-form-item{
            margin-bottom:60px;
        }
        .p1{
            font-size: 16px;
            font-weight: 500;
            color: #333333;
        }
        .p2{
            font-size: 12px;
            font-weight: 400;
            color: #777777;
        }
    }
    .tab2{
        .f4{
            border-radius: 8px;
            .d1{
                padding:15px;
                p{
                    &:first-child{
                        font-size: 16px;
                        font-weight: 500;
                        color: #333940;
                        span{
                            color:#327EFF;
                        }
                    }
                    
                }
                display: flex;
                justify-content: space-between;
                img{
                    width:16px;
                    height:16px;
                    vertical-align: middle;
                }
                .kh-btn.el-button{
                    border-radius: 15px;
                    border: 1px solid #327EFF;
                    color:#327EFF;
                }
            }
            /deep/ .el-checkbox__inner{
                border-radius: 15px;
            }
            .labelLi{
                display: flex;
                align-items: center;
                p{
                    margin-right:8px;
                    display: inline-block;
                    width:40px;
                    padding:0px 8px;
                    background: rgba(211, 236, 255, 0.4);
                    border-radius: 15px;
                    border: 1px solid rgba(0, 145, 255, 0.11);
                    font-size: 12px;
                    font-weight: 400;
                    color: #0091FF;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    // &:last-child{
                    //     padding:0 4px;
                    //     text-align: center;
                    //     // border:0;
                    //     // background:#fff;
                    // }
                    
                }
                .s{
                    background: rgba(211, 236, 255, 0.4);
                    border: 1px solid rgba(0, 145, 255, 0.11);
                    padding: 2px 10px;
                    color: #0091FF;
                    border-radius: 18px;
                    width: auto;
                }
            }
        }
    }
    .tab3{
        padding:100px 0;
        background: #fff;
        border-radius: 6px;
        p{
            margin-bottom:15px;
            text-align: center;
            img{
                width:68px;
                height:68px;
            }
            &:nth-child(2){
                font-size: 18px;
                font-weight: 400;
                color: #333333;
            }
            &:nth-child(3){
                font-size: 14px;
                font-weight: 400;
                color: #777777;
            }
            &:nth-child(4){
                font-size: 16px;
                font-weight: 500;
                color: #333333;
            }
            &:last-child{
                font-size: 14px;
                font-weight: 400;
                color: #777777;
            }
        }
    }
    .page{
        background: #fff;
        padding:30px 10px;
    }
    .userImg{
        margin-right:10px;
        width:28px;
        height:28px;
        vertical-align: middle;
    }
}
.dlog{
    padding:30px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    .t{
        margin-bottom:30px;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
    }
    .ner{
        margin-bottom:15px;
        margin-left:30px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        i{
            display: inline-block;
            margin-right:15px;
            border-radius: 50%;
            width: 6px;
            height: 6px;
            background: #0091FF;
        }
    }
    .f{
        margin-top:30px;
        margin-left:30px;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
    }
}
.dialog-footer{
    display: block;
    background: #fff;
    // padding:15px;
    // border-top:1px solid #ededed;
    .el-button{
        border-radius: 30px;
    }
}
.footer{
     display: block;
    background: #fff;
    padding:15px;
    border-top:1px solid #ededed;
    .el-button{
        border-radius: 30px;
    }
}
/deep/ .el-dialog__footer{
        border-top:1px solid #ededed;
}
</style>